import { ChevronLeft, ChevronRight, Share } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";

const isInStandaloneMode = () => {
  return window.navigator.standalone;
};
const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};
const PwaPage = ({ children }) => {
  const { t, i18n } = useTranslation();
  const [showPWAPrompt, setShowPWAPrompt] = useState(false);

  useEffect(() => {
    if (isIOS() && !isInStandaloneMode()) {
      const cookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("showPWAPromptLastShown="));
      if (!cookie) {
        setShowPWAPrompt(true);
      }
    }
  }, []);

  const handleClose = () => {
    // Set cookie with 1-day expiry
    const expires = new Date();
    expires.setHours(expires.getHours() + 24);

    document.cookie = `showPWAPromptLastShown=true; expires=${expires.toUTCString()}; path=/`;

    setShowPWAPrompt(false);
  };

  if (showPWAPrompt) {
    return (
      <div className="min-h-[100dvh] bg-white w-full flex flex-col gap-[10px] items-center justify-center px-[12%]">
        <div className="bg-[#F5F5F7] pt-6 pb-10 px-5 flex flex-col rounded-3xl w-full gap-6">
          <div className="flex items-center justify-center flex-col gap-1">
            <div className="bg-white p-2 rounded-2xl mb-4">
              <img
                src="/assets/imgs/logo1024.png"
                alt="ctelecom logo"
                className="w-9 h-9"
              />
            </div>
            <h3 className="text-base font-semibold text-black">
              {t("webApp")}
            </h3>
            <p className="text-graytext text-xs font-medium leading-5">
              {t("addTomainScreen")}
            </p>
          </div>
          <div className="flex flex-col px-5 gap-6">
            <div className="flex gap-4">
              <div className="bg-white flex items-center justify-center rounded-full w-5 h-5 text-graytext font-bold text-xs leading-5 whitespace-nowrap">
                1
              </div>
              <p className="text-graytext font-medium text-xs leading-4">
                <Trans
                  i18nKey="sharePwa"
                  components={{
                    Icon: (
                      <Share className="w-5 h-5 text-graytext inline-flex" />
                    ),
                  }}
                />
              </p>
            </div>
            <div className="flex gap-4">
              <div className="bg-white flex items-center justify-center rounded-full w-5 h-5 text-graytext font-bold text-xs leading-5 whitespace-nowrap">
                2
              </div>
              <p className="text-graytext font-medium text-xs leading-4">
                {t("addtohome")}
              </p>
            </div>
            <div className="flex gap-4">
              <div className="bg-white flex items-center justify-center rounded-full w-5 h-5 text-graytext font-bold text-xs leading-5 whitespace-nowrap">
                3
              </div>
              <p className="text-graytext font-medium text-xs leading-4">
                {t("addPwa")}
              </p>
            </div>
          </div>
        </div>
        <div
          onClick={handleClose}
          className="w-full h-[60px] bg-primary rounded-[30px] text-white flex items-center justify-center gap-1 text-xs font-medium"
        >
          {t("admissionRequest.undrestand")}{" "}
          {i18n.dir === "ltr" ? (
            <ChevronRight size={19} />
          ) : (
            <ChevronLeft size={19} />
          )}
        </div>
      </div>
    );
  }

  return <div className="h-full">{children}</div>;
};

export default PwaPage;
